(function () {
  'use strict';

  var FaqSearch = {
    init: function (container) {
      this.container = container;
      this.input = container.querySelector('.faq-search__input');
      this.clearBtn = container.querySelector('.faq-search__clear');
      this.status = container.querySelector('.faq-search__status');
      this.noResults = container.querySelector('.faq-search__no-results');
      this.noResultsText = container.dataset.noResultsText || 'No se encontraron resultados.';
      this.resultsCountText = container.dataset.resultsCountText || 'resultado(s)';

      // Collect all accordion items from the page at init time
      this.items = this._collectItems();

      if (!this.input || !this.items.length) return;

      this._bindEvents();
    },

    _collectItems: function () {
      var items = [];
      var accordions = document.querySelectorAll('collapsible-row.accordion');
      accordions.forEach(function (acc) {
        var summary = acc.querySelector('summary');
        var content = acc.querySelector('.accordion__content');
        if (!summary) return;
        items.push({
          el: acc,
          section: acc.closest('.section-collapsible-content'),
          headingText: (summary.textContent || '').replace(/[\n\r]/g, ' ').trim(),
          bodyText: content ? (content.textContent || '').replace(/[\n\r]/g, ' ').trim() : ''
        });
      });
      return items;
    },

    _bindEvents: function () {
      var self = this;

      this.input.addEventListener('input', function () {
        self._onInput();
      });

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', function () {
          self.input.value = '';
          self.input.focus();
          self._onInput();
        });
      }
    },

    _onInput: function () {
      var query = this.input.value.trim();
      this._toggleClear(query.length > 0);

      if (!query) {
        this._showAll();
        this._setStatus('');
        return;
      }

      var tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
      var matchCount = 0;
      var sections = new Set();

      this.items.forEach(function (item) {
        var combined = (item.headingText + ' ' + item.bodyText).toLowerCase();
        var matches = tokens.every(function (token) {
          return combined.indexOf(token) !== -1;
        });

        if (matches) {
          item.el.removeAttribute('data-faq-hidden');
          matchCount++;
          if (item.section) sections.add(item.section);
        } else {
          item.el.setAttribute('data-faq-hidden', 'true');
        }
      });

      // Show/hide entire sections
      var allSections = document.querySelectorAll('.section-collapsible-content');
      allSections.forEach(function (sec) {
        if (sections.has(sec)) {
          sec.removeAttribute('data-faq-empty');
        } else {
          sec.setAttribute('data-faq-empty', 'true');
        }
      });

      this._updateNoResults(matchCount === 0);
      this._setStatus(matchCount > 0 ? matchCount + ' ' + this.resultsCountText : '');
    },

    _showAll: function () {
      this.items.forEach(function (item) {
        item.el.removeAttribute('data-faq-hidden');
      });
      document.querySelectorAll('.section-collapsible-content').forEach(function (sec) {
        sec.removeAttribute('data-faq-empty');
      });
      this._updateNoResults(false);
    },

    _toggleClear: function (show) {
      if (!this.clearBtn) return;
      this.clearBtn.style.display = show ? 'block' : 'none';
      var icon = this.container.querySelector('.faq-search__icon');
      if (icon) icon.style.display = show ? 'none' : 'block';
    },

    _updateNoResults: function (show) {
      if (!this.noResults) return;
      this.noResults.style.display = show ? 'block' : 'none';
    },

    _setStatus: function (text) {
      if (!this.status) return;
      this.status.textContent = text;
    }
  };

  function injectFaqStructuredData(items) {
    var placeholder = document.querySelector('[data-faq-structured-data]');
    if (!placeholder) return;

    var entities = items
      .filter(function (item) {
        return item.headingText && item.bodyText;
      })
      .map(function (item) {
        return {
          '@type': 'Question',
          name: item.headingText,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.bodyText
          }
        };
      });

    if (!entities.length) return;

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: entities
    });
    placeholder.parentNode.replaceChild(script, placeholder);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.faq-search[data-faq-search]');
    if (container) {
      FaqSearch.init(container);
      injectFaqStructuredData(FaqSearch.items);
    }
  });
})();
